import React from 'react';
import './styles.css';
import {
    sat, 
    seguridad, 
    usuario, 
    xml
} from './NOMINA/imagenesNomina'

export default function DescripcionNomina(props){


    return(<>
     <div className='contenedorDescripcionNomina'>
        <div className='contenedorGeneralDescripcionNomina'>
        <div className='contenedorTituloDescripcionNomina'>
            <p>¿POR QUÉ ADQUIRIR T&T NÓMINA?</p>
        </div>
        <div className='caracteristicasDescripcionNomina'>
            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionNomina'>
                    <img src={usuario}/>
                </div>
                <div className='contenedorDescripcionNominaImagen'>
                    <p>Sistema <br/> Multiusuario</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionNomina'>
                    <img src={sat}/>
                </div>
                <div className='contenedorDescripcionNominaImagen'>
                    <p>Cancelación<br/> directa en el SAT</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionNomina'>
                    <img src={xml}/>
                </div>
                <div className='contenedorDescripcionNominaImagen'>
                    <p>Carga y descarga <br/> de XML</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={seguridad}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Seguridad por <br/> usuario y función</p>
                </div>
            </div>
        </div>
    </div>
</div>
    </>)
}